export default __webpack_public_path__ + "static/media/whatsapp.c8cdd8f4.svg";